import { render, staticRenderFns } from "./WelcomeCoins.vue?vue&type=template&id=73a62194&scoped=true&"
import script from "./WelcomeCoins.vue?vue&type=script&lang=ts&"
export * from "./WelcomeCoins.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeCoins.vue?vue&type=style&index=0&id=73a62194&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a62194",
  null
  
)

export default component.exports